export const SET_APP_LOADED = "SET_APP_LOADED";
export const UPDATE_ACCOUNT = "UPDATE_ACCOUNT";
export const UPDATE_ACCOUNT_DETAILS = "UPDATE_ACCOUNT_DETAILS";
export const UPDATE_BANKS = "UPDATE_BANKS";
export const UPDATE_ACCOUNT_BANKS = "UPDATE_ACCOUNT_BANKS";
export const UPDATE_EARNINGS = "UPDATE_EARNINGS";
export const UPDATE_SUBSCRIPTIONS = "UPDATE_SUBSCRIPTIONS";
export const SAVE_WITHDRAWAL_DATES = "SAVE_WITHDRAWAL_DATES";
